import { useMutation, useQuery } from 'react-query';
import { ErrorResponse } from 'react-router-dom';

import {
  fetchKPIRestaurantRequest,
  fetchPeriodStatsRestaurantRequest,
  fetchStripeCheckoutSessionRequest,
  fetchStripePortalSessionRequest,
  fetchSubscriptionsRestaurantRequest,
  RestaurantKPIResponse,
  RestaurantPeriodStatsResponse,
  SubscriptionsResponse
} from '../lib/subscription';
import { UseQueryConfig } from '../lib/types';

export const useFetchSubscriptionsQuery = ({ restaurantId }: any, config?: UseQueryConfig<SubscriptionsResponse>) => {
  return useQuery<SubscriptionsResponse, ErrorResponse>({
    queryKey: ['subscriptions', restaurantId],
    queryFn: () => fetchSubscriptionsRestaurantRequest(restaurantId),
    ...config
  });
};

export const useFetchStripePortalSessionMutation = () => {
  return useMutation<{ url: string }, ErrorResponse, string>(fetchStripePortalSessionRequest);
};

export const useFetchKPIRestaurantMutation = ({ onSuccess }: { onSuccess?: (response: RestaurantKPIResponse) => void }) => {
  return useMutation<RestaurantKPIResponse, ErrorResponse, { restaurantId: string; startDate: string; endDate: string }>(
    ({ restaurantId, startDate, endDate }) => fetchKPIRestaurantRequest(restaurantId, startDate, endDate),
    {
      onSuccess: (data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      }
    }
  );
};

export const useFetchPeriodStatsRestaurantMutation = ({ onSuccess }: { onSuccess?: (response: RestaurantPeriodStatsResponse) => void }) => {
  return useMutation<RestaurantPeriodStatsResponse, ErrorResponse, { restaurantId: string; startDate: string; endDate: string }>(
    ({ restaurantId, startDate, endDate }) => fetchPeriodStatsRestaurantRequest(restaurantId, startDate, endDate),
    {
      onSuccess: (data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      }
    }
  );
};

export const useFetchStripeCheckoutSessionRequest = ({ onSuccess }: { onSuccess?: (response: { clientSecret: string }) => void }) => {
  return useMutation<{ clientSecret: string }, ErrorResponse, { restaurantId: string; cityId: string }>(
    ({ restaurantId, cityId }) => fetchStripeCheckoutSessionRequest(restaurantId, cityId),
    {
      onSuccess: (data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      }
    }
  );
};
